export enum OptionType {
    DEFAULT = 'default',
    NONE = 'none',
    OTHER = 'other'
}
